import { useParams } from 'react-router-dom';

export const useRouteParams = <TParams>() => useParams() as any as TParams;
